import { Button, Center, Loader, Table } from "@mantine/core";
import { useCallback, useEffect, useState } from "react";
import { Link } from "wouter";
import { adminGetPluginOptions } from "../../api";
import AdminPluginOptionEdit from "./AdminPluginOptionEdit";

export default function AdminPluginOptionsList({ params }) {
  const [data, setData] = useState(null);
  const [selectedId, setSelectedId] = useState(null);

  const loadData = useCallback(() => {
    adminGetPluginOptions(params.id).then((data) => {
      console.debug("Loaded plugin options data:", data);
      setData(data);
    });
  }, [params.id]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  if (!data)
    return (
      <Center>
        <Loader mt="xl" size="xl" />
      </Center>
    );

  return (
    <div>
      {selectedId && (
        <AdminPluginOptionEdit
          pluginId={params.id}
          option={data.options.find((p) => p.id === selectedId)}
          values={data.values.filter((p) => p.genOptionId === selectedId)}
          onClose={() => setSelectedId(null)}
          onSaved={() => {
            loadData();
          }}
        />
      )}
      <Button component={Link} to="styles/new">
        Add Style
      </Button>
      <Table>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Title</Table.Th>
            <Table.Th>Medium</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {data.options?.map((p) => (
            <Table.Tr
              key={p.id}
              onClick={() => {
                console.log("setting selected id", p.id);
                setSelectedId(p.id);
              }}
              // </Table.Tbody>onClick={() => setLocation(`options/${p.id}`)}
            >
              <Table.Td>{p.title}</Table.Td>
              <Table.Td>{p.mediaClass}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </div>
  );
}
